




































import { Component, Vue } from "vue-property-decorator";
import { Search, Grid, GridItem, Cell, CellGroup } from 'vant';
import { ErrorInfo } from "@/network/http";
import { getQueryParam } from "@/utils/index";
import { setup, formatMessage } from "@/locale"
import { AreaInfo, defaultCity } from '@/data/local/common'
import CitySelector from "@/components/CitySelector.vue";
import AccountLayout from "@/components/AccountLayout.vue";
import MainBanner from "@/components/MainBanner.vue";
import MainArchives from "@/components/MainArchives.vue";
import { getModule } from 'vuex-module-decorators';
import CommonStore from '@/store/modules/common';

const commonModule = getModule(CommonStore);

Vue.use(Search);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Cell);
Vue.use(CellGroup);

@Component({
  components: {
    "v-city-selector": CitySelector,
    "v-account-layout": AccountLayout,
    "v-main-banner": MainBanner,
    "v-main-archives": MainArchives,
  }
})
export default class Home extends Vue {
  searchKey: string = "";
  defaultKey: string = "公积金如何提取";
  city: AreaInfo = defaultCity;

  iconWenda: any = require("../assets/images/ic_wenda.png");
  iconZdyw: any = require("../assets/images/ic_zdyw.png");
  iconCjwt: any = require("../assets/images/ic_cjwt.png");
  iconYwwd: any = require("../assets/images/ic_wangdian.png");
  iconCalc: any = require("../assets/images/ic_calc.png");

  mounted() {
    let lang: string = getQueryParam(this.$route, "lang");

    if (lang) {
      //设置语言
      setup(lang);
    }

    commonModule.fetchAreas();
  }

  onClear() {
    this.searchKey = "";
  }

  onSearch() {
    this.$router.push({path: "/fund/faq/search/" + this.city.id, query:{ keyword: encodeURI(this.searchKey)}});
  }

  onSelectCity(city: AreaInfo) {
    this.city = city;
  }

  onCalc() {
    window.location.href="https://b.jianbing.com/gjj/tools/financing/loan/index.php?gjjad=none";
  }

  onFindWd() {
    window.location.href = "http://gjj.sz.gov.cn/map";
  }

  toForum() {
    this.$router.push({path: "/fund/forum/list/" + this.city.id});
  }

  toZdyw() {
    this.$router.push({path: "/fund/zdyw/list/" + this.city.id});
  }

  toFaq() {
    this.$router.push({path: "/fund/faq/list/" + this.city.id});
  }
}
